// extracted by mini-css-extract-plugin
export default {"cls1":"Tx0gfqoX1tOr7wCbWiQs","cls2":"oK4CPUh9gFsJ7xj0nt5E Tx0gfqoX1tOr7wCbWiQs"};